<template>
  <div class="container">
    <div class="channel-body">
      <a href="http://m.me/vocetelecom">
        <img class="icon" src="../../public/msg.png" />
        <p>Solicite seu plano</p>
        <p>pelo messenger</p>
      </a>
      <a
        href="https://api.whatsapp.com/send?phone=559633333333&text=Eu%20quero%20INTERNET%20ULTRA"
      >
        <img class="icon" src="../../public/zap.png" />
        <p>Solicite seu plano</p>
        <p>pelo whatsapp</p>
      </a>
      <a href="https://multicanal1.smartisp.com.br/Chat/id/vocetelecom">
        <img class="icon" src="../../public/site.png" />
        <p>Solicite seu plano</p>
        <p>pelo site</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
   mounted() {
      this.$parent.changeToGrid()
  }
}
</script>

<style lang="scss" scoped>
.container {
        font-family: "Roboto", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        overflow: hidden;
        padding: 2rem 4rem;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .channel-body {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-right: -50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        justify-content: space-around;
        width: 40em;
        background: #fafafa 0% 0% no-repeat padding-box;
        box-shadow: 0px 20px 20px #4605894d;
        border-radius: 48px;
        padding: 90px;
      }

      p {
        margin: 0;
      }

      a {
        text-decoration: none;
      }

      .channel-body a {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      }

      .channel-body a p {
        color: #ff8412;
      }

      .channel-body p + p {
        font-weight: bold;
      }

      .icon {
        width: 50px;
        height: 50px;
        margin-bottom: 1em;
      }

      .logo {
        width: 120px;
      }

      @media only screen and (min-width: 320px) and (max-width: 480px) {
        .channel-body {
          top: 50%;
          left: 50%;
          margin-right: -50%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          width: inherit;
          flex-direction: column;
          padding: 70px;
        }

        .channel-body a {
          margin-top: 2em;
        }
      }
</style>
